import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";
import type { Priority, Status } from "@/lib/types";

export function Badge({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium",
        "border bg-secondary/60",
        className,
      )}
      {...props}
    />
  );
}

const priorityClass: Record<Priority, string> = {
  P0: "bg-priority-p0/15 text-priority-p0 border-priority-p0/30",
  P1: "bg-priority-p1/15 text-priority-p1 border-priority-p1/40",
  P2: "bg-priority-p2/15 text-priority-p2 border-priority-p2/40",
};

export function PriorityBadge({ priority }: { priority: Priority }) {
  return <Badge className={cn("border", priorityClass[priority])}>{priority}</Badge>;
}

const statusClass: Record<Status, { label: string; cls: string }> = {
  planned: { label: "Planned", cls: "bg-muted text-muted-foreground border-border" },
  in_progress: { label: "In progress", cls: "bg-priority-p2/10 text-priority-p2 border-priority-p2/30" },
  done: { label: "Done", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  cancelled: { label: "Cancelled", cls: "bg-destructive/10 text-destructive border-destructive/30" },
};

export function StatusBadge({ status }: { status: Status }) {
  const { label, cls } = statusClass[status];
  return <Badge className={cls}>{label}</Badge>;
}
